import { GetYouTubeThumbnail } from './useVideoEmbed.types'

const useVideoEmbed = () => {
  const youTubeRegex =
    /https:\/\/(?:www\.)?(?:youtube|youtu)\.(?:com|be)\/(?:watch\?v=|shorts\/)?([\w-]+)/

  const isValidYouTubeURL = (text?: string) => {
    const match = text?.match(youTubeRegex)
    return match && match.length > 1
  }

  const extractYouTubeVideoId = (text?: string) => {
    if (!isValidYouTubeURL(text)) {
      return undefined
    }

    const match = text?.match(youTubeRegex)

    return match?.[1]
  }

  const getYouTubeThumbnail = ({ videoId, resolution = 'sd' }: GetYouTubeThumbnail) => {
    const thumbnails = {
      hd: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      sd: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
      high: `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`,
      medium: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
      low: `https://img.youtube.com/vi/${videoId}/default.jpg`
    }

    return thumbnails[resolution]
  }

  return {
    youTube: {
      isValidURL: isValidYouTubeURL,
      extractVideoId: extractYouTubeVideoId,
      getThumbnail: getYouTubeThumbnail
    }
  }
}

export default useVideoEmbed
